import {ClientModel} from "./client";
import React from "react";
import {CompanyName} from "../components/sharedComponents/companyName/companyName";
import {Regon} from "../components/sharedComponents/regon/regon";
import {Nip} from "../components/sharedComponents/nip/nip";


interface InsurerCompanyDataProps {
    client: ClientModel;
    disabled?: boolean;
    recalculate?: boolean;
}

const InsurerCompanyData: React.FC<InsurerCompanyDataProps> = (props) => {

    return (
        <div className="company">
            <CompanyName value={props.client.companyName} disabled={props.disabled}/>
            <Regon value={props.client.regon} recalculate={props.recalculate}
                   disabled={props.disabled}/>
            <Nip value={props.client.nip} recalculate={props.recalculate}
                 disabled={props.disabled}/>
        </div>
    );
};

export default InsurerCompanyData;